module.exports = __webpack_public_path__ + "img/home-bg-1.d82b9543.png";